module.exports = __webpack_public_path__ + "media/images/athletes/3597-2a5db91dc0f6e144465e72fc0b49eb97.png";